import { GET_ALERT_RESOLUTION_TYPES, GET_ALERT_RESOLUTION_TYPES_URL} from '../constants/constants';
import { getAxiosHeaders, getService } from '../../library/RestAPI';

export async function getAlertResolutionTypes(id) {
    const options = {
        method: "GET",
        url: `${GET_ALERT_RESOLUTION_TYPES_URL}`,
        headers: getAxiosHeaders(true)
    };

    const response = await getService(options);
    if(response) {
        return response.data
    }
};
